/**
 * Text Scope enum
 *
 * Defines the different contexts where text entities can be used.
 * This enum corresponds to the backend TextScope enum.
 */
export enum TextScope {
  Offer = 'Offer',
  Contract = 'Contract',
  Invoice = 'Invoice',
  ProofOfQuantity = 'ProofOfQuantity'
}
